// extracted by mini-css-extract-plugin
export default {"white":"#fff","checkbox":"Checkbox_checkbox__stDHN","dark":"Checkbox_dark__98pkP","container":"Checkbox_container__RmND-"};